import { useNavigate, useSearchParams } from 'react-router-dom';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { IconName } from '../../../../shared/interfaces/icon-picker.model';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';
import { useContext, useEffect, useRef, useState } from 'react';
import { ICapitalGood } from '../../../../shared/services/capital-good/capital-good.model';
import { Grid, Tab, Tabs, ToggleButton, ToggleButtonGroup, Stack, useMediaQuery, Box } from '@mui/material';
import { GridView, MenuOutlined } from '@mui/icons-material';
import { CustomTabPanel } from '../../../presentation-components/display-elements-components/custom-tab-panel';
import { TableDisplay } from '../../../presentation-components/miscellaneous-components/table-display';
import { TableActionButtons } from '../../../presentation-components/miscellaneous-components/table-action-buttons';
import { IHeadCell } from '../../../../shared/interfaces/table-display.model';
import gaiaTheme from '../../../../root-components/theme';
import { SearchBar } from '../../../presentation-components/display-elements-components/search-bar';
import { LoadingPage } from '../../loading-page';
import SuperAdminService from '../../../../shared/services/super-admin/super-admin.service';
import { IGoodCategory, IPostGoodCategory } from '../../../../shared/services/good-category/good-category.model';
import { deleteQueryParamFromUrl } from '../../../../shared/utils/misc-shared-utils';
import { GoodCategoryDialog } from '../../../dialogs/settings/good-category-dialog';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { IManufacturer, IPostManufacturer } from '../../../../shared/services/manufacturer/manufacturer.model';
import { ManufacturerDialog } from '../../../dialogs/organisation/add-manufacturer-dialog';
import { GoodCatalogueTree } from '../../../presentation-components/organisation-components/good/good-catalogue-tree';
import { InformationBox } from '../../../presentation-components/miscellaneous-components/information-box';
import { EmissionsInputCard } from '../../../presentation-components/emissons-components/overview/emissions-display/emissions-input-card';
import GoodCategoryService from '../../../../shared/services/good-category/good-category.service';
import CapitalGoodService from '../../../../shared/services/capital-good/capital-good-service';
import { useDebounce } from '../../../../hooks/use-debounce-hook';

export const SuperAdminGoodsPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  //Services
  const superAdminService = new SuperAdminService()
  const goodCategoryService = new GoodCategoryService();
  const capitalGoodService = new CapitalGoodService();
  //Context
  const userNotificationsContext = useContext(UserNotificationsContext)
  //State
  const [allGlobalGoods, setAllGlobalGoods] = useState<ICapitalGood[]>();
  const [goodCategories, setGoodCategories] = useState<IGoodCategory[]>();
  const [goodCategoryId, setGoodCategoryId] = useState<string>()
  const [manufacturers, setManufacturers] = useState<IManufacturer[]>();
  const [manufacturerId, setManufacturerId] = useState<string>()
  const [tab, setTab] = useState(0);
  const [viewMode, setViewMode] = useState<'table' | 'grid'>('grid');
  const [capitalGoodsInCategory, setCapitalGoodsInCategory] = useState<ICapitalGood[]>([]);
  const [goodCatalogue, setGoodCatalogue] = useState<any>()
  const [selectedCatalogueItemId, setSelectedCatalogueItemId] = useState<string | null>(null);
  const [searchQueryGoods, setSearchQueryGoods] = useState('')
  const [searchQueryGoodCategories, setSearchQueryGoodCategories] = useState('')
  const [searchQueryManufacturers, setSearchQueryManufacturers] = useState('')
  const [openDialogGoodCategory, setOpenDialogGoodCategory] = useState(false);
  const [openDialogManufacturer, setOpenDialogManufacturer] = useState(false);
  //Table State
  const [selected, setSelected] = useState<string[]>([]);
  const [inputPageGoods, setInputPageGoods] = useState(0);
  const [inputPageGoodCategories, setInputPageGoodCategories] = useState(0);
  const [totalRecordsGoods, setTotalRecordsGoods] = useState(0)
  const [totalRecordsGoodCategories, setTotalRecordsGoodCategories] = useState(0)
  const [perPageGoods, setPerPageGoods] = useState(10)
  const [perPageGoodCategories, setPerPageGoodCategories] = useState(10)
  const [changeGoods, setChangeGoods] = useState<number>(0)
  const [changeGoodCategories, setChangeGoodCategories] = useState<number>(0)
  const [orderByGoods, setOrderByGoods] = useState<string>()
  const [orderByGoodCategories, setOrderByGoodCategories] = useState<string>()
  const [orderGoods, setOrderGoods] = useState<'asc' | 'desc'>()
  const [orderGoodCategories, setOrderGoodCategories] = useState<'asc' | 'desc'>()
  const [inputPageManufacturers, setInputPageManufacturers] = useState(0)
  const [totalRecordsManufacturers, setTotalRecordsManufacturers] = useState(0)
  const [perPageManufacturers, setPerPageManufacturers] = useState(10)
  const [changeManufacturers, setChangeManufacturers] = useState<number>(0)
  const [orderByManufacturers, setOrderByManufacturers] = useState<string>()
  const [orderGoodManufacturers, setOrderGoodManufacturers] = useState<'asc' | 'desc'>()
  //Loading State
  const [hasPageMountedGoods, setHasPageMountedGoods] = useState<boolean>(false)
  const [hasPageMountedGoodCategories, setHasPageMountedGoodCategories] = useState<boolean>(false)
  const [hasPageMountedManufacturers, setHasPageMountedManufacturers] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isDialogSubmitting, setIsDialogSubmitting] = useState<boolean>(false)
  //Hooks
  const debouncedSearchQueryGoods = useDebounce(searchQueryGoods, 500);
  const debouncedSearchQueryGoodCategories = useDebounce(searchQueryGoodCategories, 500);
  const debouncedSearchQueryManufacturers = useDebounce(searchQueryManufacturers, 500);
  //Ref
  const requestIdGoods = useRef<number>(0)
  const requestIdGoodCategories = useRef<number>(0)
  const requestIdManufacturers = useRef<number>(0)

  //Layout
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));
  //Use Effects
  useEffect(() => {
    if (tab === 0) {
      requestIdGoods.current++
      const currentRequestId = requestIdGoods.current
      superAdminService.getAllGoodsWithPagination(debouncedSearchQueryGoods, inputPageGoods, perPageGoods, orderByGoods, orderGoods)
        .then(response => {
          if (currentRequestId === requestIdGoods.current) {
            setIsLoading(false)
            setTotalRecordsGoods(response.count);
            setAllGlobalGoods(response.rows)
          }
        })
        .catch(err => {
          if (currentRequestId === requestIdGoods.current) {
            setIsLoading(false)
          }
          console.log(err)
        })
    } else if (tab === 1) {
      getAllGoodCategories()
    } else if (tab === 2) {
      getAllManufacturers()
    }
  }, [tab, inputPageGoods, perPageGoods, changeGoods, orderByGoods, orderGoods, inputPageGoodCategories, perPageGoodCategories, changeGoodCategories, changeManufacturers, orderByGoodCategories, orderGoodCategories, orderGoodManufacturers, debouncedSearchQueryGoods, debouncedSearchQueryGoodCategories, debouncedSearchQueryManufacturers])

  const getAllGoodCategories = () => {
    requestIdGoodCategories.current++
    const currentRequestId = requestIdGoodCategories.current
    superAdminService.getAllGoodCategoriesWithPagination(debouncedSearchQueryGoodCategories, inputPageGoodCategories, perPageGoodCategories, orderByGoodCategories, orderGoodCategories)
      .then(response => {
        if (currentRequestId === requestIdGoodCategories.current) {
          setIsLoading(false)
          setTotalRecordsGoodCategories(response.count);
          setGoodCategories(response.rows)
        }
      })
      .catch(err => {
        if (currentRequestId === requestIdGoodCategories.current) {
          setIsLoading(false)
        }
        console.log(err)
      })
  }

  const getAllManufacturers = () => {
    requestIdManufacturers.current++
    const currentRequestId = requestIdManufacturers.current
    superAdminService.getAllManufacturersWithPagination(debouncedSearchQueryManufacturers, inputPageManufacturers, perPageManufacturers, orderByManufacturers, orderGoodManufacturers)
      .then(response => {
        if (currentRequestId === requestIdManufacturers.current) {
          setIsLoading(false)
          setTotalRecordsManufacturers(response.count);
          setManufacturers(response.rows)
        }
      })
      .catch(err => {
        if (currentRequestId === requestIdManufacturers.current) {
          setIsLoading(false)
        }
        console.log(err)
      })
  }

  useEffect(() => {
    if (hasPageMountedGoods) {
      if (inputPageGoods === 0) {
        setChangeGoods(c => c + 1)
      } else {
        setInputPageGoods(0)
      }
    }
    setHasPageMountedGoods(true)
  }, [orderGoods, orderByGoods, debouncedSearchQueryGoods, inputPageGoods])

  useEffect(() => {
    if (hasPageMountedGoodCategories) {
      if (inputPageGoodCategories === 0) {
        setChangeGoodCategories(c => c + 1)
      } else {
        setInputPageGoodCategories(0)
      }
    }
    setHasPageMountedGoodCategories(true)
  }, [orderGoodCategories, orderByGoodCategories, debouncedSearchQueryGoodCategories, inputPageGoodCategories])

  useEffect(() => {
    if (hasPageMountedManufacturers) {
      if (inputPageManufacturers === 0) {
        setChangeManufacturers(c => c + 1)
      } else {
        setInputPageManufacturers(0)
      }
    }
    setHasPageMountedManufacturers(true)
  }, [orderGoodManufacturers, orderByManufacturers, debouncedSearchQueryManufacturers, inputPageManufacturers])

  useEffect(() => {
    if (searchParams.has('tabId')) {
      const tab = searchParams.get('tabId')
      if (tab) {
        setTab(parseInt(tab))
      }
      deleteQueryParamFromUrl(searchParams, 'tabId')
    }

    if (searchParams.has('openDialog')) {
      if (searchParams.get('openDialog') === 'true') {
        setOpenDialogGoodCategory(true);
        deleteQueryParamFromUrl(searchParams, 'openDialog')
      }
      deleteQueryParamFromUrl(searchParams, 'openDialog')
    }
  }, [searchParams])

  useEffect(() => {
    goodCategoryService.getAllForCatalogue(`?superAdmin=true`)
      .then((response: any) => {
        setGoodCatalogue(response)
        const defaultSelectedId = response[0].id;
        setSelectedCatalogueItemId(defaultSelectedId);
        capitalGoodService.getAll(`?superAdmin=true&goodCategory=true&category=${encodeURIComponent(defaultSelectedId)}`)
          .then((response: ICapitalGood[]) => {
            setCapitalGoodsInCategory(response)
          })
          .catch((err: any) => console.log(err))
      })
      .catch((err: any) => console.log(err))
  }, [])


  // Table configuration Goods
  const headCells: IHeadCell[] = [
    { id: 'name', label: 'Product', numeric: false, sortable: true },
    { id: 'modelNumber', label: 'Model', numeric: false, sortable: true },
    { id: 'category', label: 'Category', numeric: false, sortable: false },
    { id: 'manufacturerName', label: 'Manufacturer', numeric: false, sortable: true },
    { id: 'emissionPerUnit', label: 'Emissions', numeric: true, sortable: false },
    { id: 'status', label: 'Status', numeric: false, sortable: true }
  ];

  const rows = !allGlobalGoods ? [] : allGlobalGoods.map(product => {
    const categoryParts = [
      product.goodCategory?.category,
      product.goodCategory?.subCategoryOne,
      product.goodCategory?.subCategoryTwo
    ].filter(Boolean);
    return {
      id: product.id,
      name: product.name,
      modelNumber: product.modelNumber,
      category: categoryParts.join(', '),
      manufacturerName: product.manufacturer?.name ?? '',
      emissionPerUnit: `${product.kgCarbonEmission} kgCO2e per ${product.unitAmount} per ${product.measurementUnit.name}`,
      status: product.active ? 'Active' : 'Inactive',
    };
  });

  // Table configuration Good Categories
  const headCellsGoodCategories: IHeadCell[] = [
    { id: 'action', label: 'Action', numeric: false, sortable: false },
    { id: 'category', label: 'Category', numeric: false, sortable: true },
    { id: 'subCategoryOne', label: 'Subcategory 1', numeric: false, sortable: true },
    { id: 'subCategoryTwo', label: 'Subcategory 2', numeric: false, sortable: true },
    { id: 'status', label: 'Status', numeric: false, sortable: true }
  ];

  const rowsGoodCategories = !goodCategories ? [] : goodCategories.map(gc => ({
    id: gc.id,
    action: (
      <TableActionButtons
        id={gc.id}
        includeEdit={true}
        includeOther={!gc.active}
        otherButtonIcon={IconName.CheckCircle}
        otherButtonText={'Activate'}
        onOther={(id: string) => activateGoodCategoryHandler(id)}
        onEdit={(id: string) => editClickGoodCategoryHandler(id)}
      />
    ),
    category: gc.category,
    subCategoryOne: gc.subCategoryOne || '',
    subCategoryTwo: gc.subCategoryTwo || '',
    status: gc.active ? 'Active' : 'Inactive',
  }));

  const editClickGoodCategoryHandler = (goodCategoryId: string) => {
    setGoodCategoryId(goodCategoryId)
    setOpenDialogGoodCategory(true)
  }

  const activateGoodCategoryHandler = (goodCategoryId: string) => {
    superAdminService.activateGoodCategory(goodCategoryId)
      .then(() => {
        getAllGoodCategories()
        userNotificationsContext.openSnackbar({ open: true, message: `Updated successfully` });
      })
      .catch(err => {
        console.log(err)
        userNotificationsContext.openSnackbar({ open: true, message: `There was an error, please try again`, backgroundColor: 'text.primary' })
      })
  }

  // Table configuration Manufacturers
  const headCellsManufacturers: IHeadCell[] = [
    { id: 'action', label: 'Action', numeric: false, sortable: false },
    { id: 'name', label: 'Manufacturer', numeric: false, sortable: true },
    { id: 'status', label: 'Status', numeric: false, sortable: true }
  ];

  const rowsManufacturers = !manufacturers ? [] : manufacturers.map(mf => ({
    id: mf.id,
    action: (
      <TableActionButtons
        id={mf.id}
        includeEdit={true}
        includeOther={!mf.active}
        otherButtonIcon={IconName.CheckCircle}
        otherButtonText={'Activate'}
        onOther={(id: string) => activateManufacturerHandler(id)}
        onEdit={(id: string) => editClickManufacturerHandler(id)}
      />
    ),
    name: mf.name,
    status: mf.active ? 'Active' : 'Inactive',
  }));

  const editClickManufacturerHandler = (manufacturerId: string) => {
    setManufacturerId(manufacturerId)
    setOpenDialogManufacturer(true)
  }

  const activateManufacturerHandler = (manufacturerId: string) => {
    superAdminService.activateManufacturer(manufacturerId)
      .then(() => {
        getAllManufacturers()
        userNotificationsContext.openSnackbar({ open: true, message: `Updated successfully` });
      })
      .catch(err => {
        console.log(err)
        userNotificationsContext.openSnackbar({ open: true, message: `There was an error, please try again`, backgroundColor: 'text.primary' })
      })
  }


  const handleItemSelectionToggle = (event: React.SyntheticEvent | null, itemId: string, isSelected: boolean,) => {
    if (isSelected) {
      const parts = itemId.split('-')
      setSelectedCatalogueItemId(parts[0])
      capitalGoodService.getAll(`?superAdmin=true&goodCategory=true&category=${encodeURIComponent(parts[0])}${parts[1] ? `&subCategoryOne=${encodeURIComponent(parts[1])}${parts[2] ? `&subCategoryTwo=${encodeURIComponent(parts[2])}` : ''}` : ''}`)
        .then(response => {
          setCapitalGoodsInCategory(response)
        })
        .catch(err => console.log(err))
    }
  };

  //Table Event Handlers 
  const handleSelected = (selectedRowId: string[]) => {
    if (selectedRowId[0] !== undefined) {
      navigate(`/super-admin/products/${selectedRowId[0]}`)
    }
  }

  const handleOrderChange = (orderBy: string, order: 'asc' | 'desc') => {
    if (tab === 0) {
      setOrderByGoods(orderBy)
      setOrderGoods(order)
    } else if (tab === 1) {
      setOrderByGoodCategories(orderBy)
      setOrderGoodCategories(order)
    } else if (tab === 2) {
      setOrderByManufacturers(orderBy)
      setOrderGoodManufacturers(order)
    }
  };

  const handleViewModeChange = (event: React.MouseEvent<HTMLElement>, newViewMode: 'table' | 'grid') => {
    if (newViewMode !== null) {
      setViewMode(newViewMode);
    }
  };


  //Dialog Event Handlers
  const submitDialogGoodCategoryHandler = (values: IPostGoodCategory, resetForm: () => void, isEdit: boolean,) => {
    if (!isEdit) {
      if (!isDialogSubmitting) {
        setIsDialogSubmitting(true)
        superAdminService.createGoodCategory(values)
          .then(response => {
            getAllGoodCategories()
            resetForm();
            setOpenDialogGoodCategory(false)
            userNotificationsContext.openSnackbar({ open: true, message: `Saved successfully` });
            setIsDialogSubmitting(false)
          })
          .catch(err => {
            if (err.response.data.code === 1) {
              userNotificationsContext.openDialog({
                active: true, title: 'Duplicated Category',
                message: `A category with the same name and subcategories already exists. Please use a unique combination or modify the existing entry.`,
                buttonCopy: 'Ok',
                hideCancelButton: true
              })
            } else if (err.response.data.code === 2) {
              userNotificationsContext.openDialog({
                active: true, title: 'Action Not Allowed',
                message: `Subcategory 2 cannot exist without Subcategory 1. Please enter Subcategory 1 first.`,
                buttonCopy: 'Ok',
                hideCancelButton: true
              })
            } else {
              userNotificationsContext.openSnackbar({ open: true, message: `There was an error, please try again`, backgroundColor: 'text.primary' })
              resetForm()
              setOpenDialogGoodCategory(false)
            }
            setIsDialogSubmitting(false)
          })
      }
    }
    if (isEdit && goodCategoryId) {
      if (!isDialogSubmitting) {
        setIsDialogSubmitting(true)
        superAdminService.updateGoodCategory(goodCategoryId, values)
          .then(response => {
            getAllGoodCategories()
            resetForm();
            setOpenDialogGoodCategory(false)
            setGoodCategoryId('')
            userNotificationsContext.openSnackbar({ open: true, message: `Updated successfully` });
            setIsDialogSubmitting(false)
          })
          .catch(err => {
            if (err.response.data.code === 1) {
              userNotificationsContext.openDialog({
                active: true, title: 'Duplicated Category',
                message: `A category with the same name and subcategories already exists. Please use a unique combination or modify the existing entry.`,
                buttonCopy: 'Ok',
                hideCancelButton: true
              })
            } else if (err.response.data.code === 2) {
              userNotificationsContext.openDialog({
                active: true, title: 'Action Not Allowed',
                message: `Subcategory 2 cannot exist without Subcategory 1. Please enter Subcategory 1 first.`,
                buttonCopy: 'Ok',
                hideCancelButton: true
              })
            } else {
              userNotificationsContext.openSnackbar({ open: true, message: `There was an error, please try again`, backgroundColor: 'text.primary' })
              resetForm()
              setOpenDialogGoodCategory(false)
            }
            setIsDialogSubmitting(false)
          })
      }
    }
  }

  const submitDialogManufacturerHandler = (values: IPostManufacturer, resetForm: () => void, isEdit: boolean,) => {
    if (manufacturerId && isEdit) {
      if (!isDialogSubmitting) {
        setIsDialogSubmitting(true)
        superAdminService.updateManufacturer(manufacturerId, values)
          .then(response => {
            getAllManufacturers()
            resetForm();
            setOpenDialogManufacturer(false)
            setManufacturerId('')
            userNotificationsContext.openSnackbar({ open: true, message: `Updated successfully` });
            setIsDialogSubmitting(false)
          })
          .catch(err => {
            userNotificationsContext.openSnackbar({ open: true, message: `There was an error, please try again`, backgroundColor: 'text.primary' })
            resetForm()
            setOpenDialogManufacturer(false)
            setIsDialogSubmitting(false)
          })
      }
    }
    else {
      setIsDialogSubmitting(true)
      superAdminService.createManufacturer(values)
        .then(response => {
          getAllManufacturers()
          resetForm();
          setOpenDialogManufacturer(false)
          userNotificationsContext.openSnackbar({ open: true, message: `Saved successfully` });
          setIsDialogSubmitting(false)
        })
        .catch(err => {
          userNotificationsContext.openSnackbar({ open: true, message: `There was an error, please try again`, backgroundColor: 'text.primary' })
          resetForm()
          setOpenDialogManufacturer(false)
          setIsDialogSubmitting(false)
        })
    }
  }


  const closeDialogGoodCategoryHandler = () => {
    setOpenDialogGoodCategory(false)
    setGoodCategoryId('')
  }

  const closeDialogManufacturerHandler = () => {
    setOpenDialogManufacturer(false)
    setManufacturerId('')
  }



  return (
    <PageOuterContainer>
      <PageHeading
        title='Global Products'
        includeBackButton={true}
        backButtonLink='/super-admin'
        backButtonText='Back to super admin'
        includeActionButton={true}
        actionButtonText={tab === 0 ? 'Add Global Product' : tab === 1 ? 'Add Global Product Category' : 'Add Global Manufacturer'}
        actionButtonIcon={IconName.Add}
        actionButtonHandler={tab === 0 ? () => { navigate('/super-admin/products/add-product') } : tab === 1 ? () => { setOpenDialogGoodCategory(true) } : tab === 2 ? () => { setOpenDialogManufacturer(true) } : null}
        hideShowActionButton={false}
      />
      <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ mb: 2 }}>
        <Tab label='Products' />
        <Tab label='Product Categories' />
        <Tab label='Manufacturers' />
      </Tabs>
      <CustomTabPanel value={tab} index={0}>
        <Stack display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' sx={{ mb: 2 }}>
          <Grid container>
            <Grid item xl={4} lg={4} md={6} sm={12} xs={12}
              sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', width: '100%' }}>
              {viewMode === 'table' && <SearchBar searchQuery={searchQueryGoods} setSearchQuery={setSearchQueryGoods} />}
              {viewMode === 'grid' && (
                <Box sx={{ visibility: 'hidden', width: '100%' }}>
                  <SearchBar searchQuery={searchQueryGoods} setSearchQuery={setSearchQueryGoods} />
                </Box>
              )}
            </Grid>
          </Grid>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={handleViewModeChange}
            orientation="horizontal"
            sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
            <ToggleButton value="grid" sx={{ width: '50px', pt: 0.5, pb: 0.5, textTransform: 'capitalize' }}>
              <GridView />
            </ToggleButton>
            <ToggleButton value="table" sx={{ width: '50px', pt: 0.5, pb: 0.5, textTransform: 'none' }}>
              <MenuOutlined />
            </ToggleButton>
          </ToggleButtonGroup>
        </Stack>
        <LoadingPage pageReady={!isLoading}>
          {viewMode === 'grid' &&
            <>
              {goodCatalogue &&
                <Grid container spacing={4}>
                  <Grid item lg={3} xs={3}>
                    <GoodCatalogueTree
                      goodCatalogue={goodCatalogue}
                      handleItemSelectionToggle={handleItemSelectionToggle}
                      selectedCatalogueItemId={selectedCatalogueItemId ? selectedCatalogueItemId : ''}
                    />
                  </Grid>
                  <Grid item lg={8} xs={8} >
                    {goodCatalogue.length > 0 && capitalGoodsInCategory && capitalGoodsInCategory.length === 0 &&
                      <InformationBox
                        icon={IconName.ErrorOutline}
                        text='You do not have any products in this category'
                        actionText='Click here to create one'
                        link={'/organisation/products/add-product'}
                        marginTop={2}
                      />
                    }
                    {capitalGoodsInCategory && capitalGoodsInCategory.length > 0 &&
                      < Grid container spacing={2}>
                        {capitalGoodsInCategory.map((good, index) => (
                          <Grid key={index} item lg={4} xs={6}  >
                            <Box sx={{ cursor: 'pointer', height: '100%', }} onClick={() => navigate(`/super-admin/products/${good.id}`)}>
                              <EmissionsInputCard
                                title={good.name}
                                description={good.manufacturer?.name}
                                backgroundColor={'secondary.light'}
                                selected={false}
                                showChip={good.active}
                                chipLabel={'Active'}
                                imageFilePath={good.capitalGoodImageFilePath}
                                icon={IconName.ShoppingBagOutlined}
                              />
                            </Box>
                          </Grid>
                        ))}
                      </Grid>}
                  </Grid>
                </Grid>}
            </>
          }
          {viewMode === 'table' && allGlobalGoods &&
            <TableDisplay
              onOrderChange={handleOrderChange}
              isMobileMode={isMobileMode}
              headCells={headCells}
              rows={rows}
              selected={selected}
              setSelected={setSelected}
              handleSelected={handleSelected}
              inputPage={inputPageGoods}
              setInputPage={setInputPageGoods}
              totalRecords={totalRecordsGoods}
              perPage={perPageGoods}
              setPerPage={setPerPageGoods} />
          }
        </LoadingPage>
      </CustomTabPanel>
      <CustomTabPanel value={tab} index={1}>
        <LoadingPage pageReady={!isLoading}>
          {goodCategories &&
            <TableDisplay
              onOrderChange={handleOrderChange}
              isMobileMode={isMobileMode}
              headCells={headCellsGoodCategories}
              rows={rowsGoodCategories}
              selected={selected}
              selectByIcon={true}
              setSelected={setSelected}
              inputPage={inputPageGoodCategories}
              setInputPage={setInputPageGoodCategories}
              totalRecords={totalRecordsGoodCategories}
              perPage={perPageGoodCategories}
              setPerPage={setPerPageGoodCategories} />}
        </LoadingPage>
        {!goodCategoryId && openDialogGoodCategory &&
          <GoodCategoryDialog
            onSubmit={submitDialogGoodCategoryHandler}
            open={openDialogGoodCategory}
            isSubmitting={isDialogSubmitting}
            closeHandler={closeDialogGoodCategoryHandler}
            isEdit={false} />}
        {goodCategoryId && openDialogGoodCategory &&
          <GoodCategoryDialog
            isSubmitting={isDialogSubmitting}
            onSubmit={submitDialogGoodCategoryHandler}
            open={openDialogGoodCategory}
            closeHandler={closeDialogGoodCategoryHandler}
            isEdit={true}
            goodCategoryId={goodCategoryId} />}
      </CustomTabPanel>
      <CustomTabPanel value={tab} index={2}>
        <LoadingPage pageReady={!isLoading}>
          {manufacturers &&
            <TableDisplay
              onOrderChange={handleOrderChange}
              isMobileMode={isMobileMode}
              headCells={headCellsManufacturers}
              rows={rowsManufacturers}
              selected={selected}
              selectByIcon={true}
              setSelected={setSelected}
              inputPage={inputPageManufacturers}
              setInputPage={setInputPageManufacturers}
              totalRecords={totalRecordsManufacturers}
              perPage={perPageManufacturers}
              setPerPage={setPerPageManufacturers} />}
        </LoadingPage>
        {manufacturerId && openDialogManufacturer &&
          <ManufacturerDialog
            isSubmitting={isDialogSubmitting}
            onSubmit={submitDialogManufacturerHandler}
            open={openDialogManufacturer}
            closeHandler={closeDialogManufacturerHandler}
            isEdit={true}
            manufacturerId={manufacturerId} />}
        {!manufacturerId && openDialogManufacturer &&
          <ManufacturerDialog
            isSubmitting={isDialogSubmitting}
            onSubmit={submitDialogManufacturerHandler}
            open={openDialogManufacturer}
            closeHandler={closeDialogManufacturerHandler}
            isEdit={false}
            manufacturerId={manufacturerId} />}
      </CustomTabPanel>
    </PageOuterContainer>
  )
};